import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import styled from "styled-components"
import Container from "../components/Container"
import SubHeader from "../components/SubHeader"
import P from "../components/P"

const HorizontalContainer = styled.div`
  min-width: 100vh;
  display: flex;
  justify-content: space-around;
  background-color: #800000;
  padding-top: 40px;
  padding-bottom: 40px;
`

const Desc = styled.h4`
  margin-top: 30px;
  font-size: 24px;
  color: #ffffff;
  font-weight: normal;
  text-align: center;
`
const VerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const H4 = styled.h4`
  font-size: 22px;
  font-weight: bold;
  margin-top: 25px;
  color: #000;
`

const WireframingSection = () => {
  const data = useStaticQuery(graphql`
    query {
      main: file(relativePath: { eq: "Main3.png" }) {
        childImageSharp {
          fixed(width: 766, height: 500, quality: 100) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
      menu: file(relativePath: { eq: "LowMenu.png" }) {
        childImageSharp {
          fixed(width: 724, height: 454, quality: 100) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
      add: file(relativePath: { eq: "LowAdding.png" }) {
        childImageSharp {
          fixed(width: 724, height: 454, quality: 100) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
      hover: file(relativePath: { eq: "LowHover.png" }) {
        childImageSharp {
          fixed(width: 724, height: 454, quality: 100) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
      reqs: file(relativePath: { eq: "LowReqs.png" }) {
        childImageSharp {
          fixed(width: 724, height: 454, quality: 100) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
      moreReqs: file(relativePath: { eq: "LowMoreReqs.png" }) {
        childImageSharp {
          fixed(width: 724, height: 454, quality: 100) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
      mainV4: file(relativePath: { eq: "LowV4Main2.png" }) {
        childImageSharp {
          fixed(width: 724, height: 454, quality: 100) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
      menuV4: file(relativePath: { eq: "LowV4Menu2.png" }) {
        childImageSharp {
          fixed(width: 724, height: 454, quality: 100) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
      reqsV4: file(relativePath: { eq: "LowV4Reqs2.png" }) {
        childImageSharp {
          fixed(width: 724, height: 454, quality: 100) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
      settingsV4: file(relativePath: { eq: "LowV4Settings2.png" }) {
        childImageSharp {
          fixed(width: 724, height: 454, quality: 100) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
      gridV4: file(relativePath: { eq: "LowV4Grid2.png" }) {
        childImageSharp {
          fixed(width: 724, height: 454, quality: 100) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
    }
  `)

  return (
    <>
      <Container noTop>
        <SubHeader>Low-Fidelity Prototyping</SubHeader>
        <P>
          We used Figma to make a low-fidelity wireframe of our proposed design
          as well as to turn into an interactive prototype. After doing so, we
          interviewed multiple students with different majors, number of majors,
          years and backgrounds. Here’s the results :
        </P>
        <H4>Wireframe V1</H4>
      </Container>
      <HorizontalContainer>
        <VerContainer>
          <Img fixed={data.main.childImageSharp.fixed} />
          <Desc>Main</Desc>
        </VerContainer>
      </HorizontalContainer>
      <HorizontalContainer>
        <VerContainer>
          <Img fixed={data.menu.childImageSharp.fixed} />
          <Desc>Left Menu</Desc>
        </VerContainer>
        <VerContainer>
          <Img fixed={data.add.childImageSharp.fixed} />
          <Desc>Adding a Course</Desc>
        </VerContainer>
      </HorizontalContainer>
      <HorizontalContainer>
        <VerContainer>
          <Img fixed={data.hover.childImageSharp.fixed} />
          <Desc>Hovering Over a Course</Desc>
        </VerContainer>
      </HorizontalContainer>
      <HorizontalContainer>
        <VerContainer>
          <Img fixed={data.reqs.childImageSharp.fixed} />
          <Desc>Requirements Menu</Desc>
        </VerContainer>
        <VerContainer>
          <Img fixed={data.moreReqs.childImageSharp.fixed} />
          <Desc>Showing Missing Requirements</Desc>
        </VerContainer>
      </HorizontalContainer>
      <Container noTop>
        <H4>Evaluation</H4>
        <P>
          After making the mockups, we started interviewing students to receive
          some feedback on our designs, after that, we would do the required
          changes. Then, we would do the process again until we are ready to
          move on to the next phase. Here some of the feedback that received
          during 4 iterations :
          <br /> <br />
          “Maybe include a color blindness mode for the green and red”
          <br /> <br />
          “I would like to see the number of credit hours for courses and per
          quarter”
          <br /> <br /> “I prefer it if it had only one side menu instead of
          two”
          <br /> <br />
          “It would be cool if we were able to drag and drop the missing course
          from the degree requirements menu”
          <br /> <br />
          “I would like it to look more like the flowchart, such as coloring.
          Also, I would like to place courses as it is shown on flowchart so I
          can put all the humanity courses at the bottom, major requirements at
          the middle, and other science electives at the top”
          <br /> <br />
          Based on this feedback we were able to make the following changes :
        </P>
        <H4>Wireframe V4</H4>
      </Container>
      <HorizontalContainer>
        <VerContainer>
          <Img fixed={data.mainV4.childImageSharp.fixed} />
          <Desc>Credit Hours in Courses and Quarters</Desc>
        </VerContainer>
      </HorizontalContainer>
      <HorizontalContainer>
        <VerContainer>
          <Img fixed={data.menuV4.childImageSharp.fixed} />
          <Desc>
            One Menu For Both <br />
            Search and Requirements
          </Desc>
        </VerContainer>
        <VerContainer>
          <Img fixed={data.reqsV4.childImageSharp.fixed} />
          <Desc>Requirements Show As Draggable Courses</Desc>
        </VerContainer>
      </HorizontalContainer>
      <HorizontalContainer>
        <VerContainer>
          <Img fixed={data.settingsV4.childImageSharp.fixed} />
          <Desc>New Settings Menu</Desc>
        </VerContainer>
        <VerContainer>
          <Img fixed={data.gridV4.childImageSharp.fixed} />
          <Desc>New Grid View</Desc>
        </VerContainer>
      </HorizontalContainer>
    </>
  )
}

export default WireframingSection
